import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';


export default class BaseIcon extends React.PureComponent {
  render() {
    const { children, height, width, viewBox, scale, className, ...rest } = this.props;
    const viewBoxToUse = viewBox || `0 0 ${width} ${height}`;
    const classes = classnames(
      'ds-icon',
      className,
    );
    return (
      <svg
        height={`${height}px`}
        width={`${width}px`}
        viewBox={viewBoxToUse}
        style={{
          transform: `scale(${scale})`,
        }}
        className={classes}
        {...rest}
      >
        {children}
      </svg>
    );
  }
}

BaseIcon.defaultProps = {
  children: null,
  className: 'ds-icon-inherit-color',
  height: 16,
  onClick: () => {},
  scale: 1,
  viewBox: '',
  width: 16,
};

BaseIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.number,
  onClick: PropTypes.func,
  scale: PropTypes.number,
  viewBox: PropTypes.string,
  width: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/BaseIcon.jsx